import { useCallback, useMemo } from 'react'
import { FileDown } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchDataExport, GDPR_KIND_OPTS, GDPR_STATUS_OPTS, LEGAL_STR as S, type GdprRow } from './legalFlowApi'

/**
 * A19.15 — Ma'lumot eksporti / subyekt so'rovi (data-subject export, read-only).
 * GDPR access/export so'rovlari — GET /admin/gdpr-requests ustidan (kind bo'yicha
 * filtrlanadi). Faqat kuzatuv (avto-eksport yo'q). Backend yo'q/xato → fail-soft.
 */
export function LegalDataExportScreen() {
  const columns = useMemo<AdminColumn<GdprRow>[]>(
    () => [
      { key: 'id', header: S.id, type: 'id', width: 70 },
      { key: 'created_at', header: S.created, type: 'date', width: 150 },
      { key: 'subject', header: S.subject, type: 'text', minWidth: 180 },
      { key: 'kind', header: S.kind, type: 'enum', width: 130, options: GDPR_KIND_OPTS },
      { key: 'reason', header: S.reason, type: 'longtext', minWidth: 180 },
      { key: 'due_at', header: S.due, type: 'date', width: 150 },
      { key: 'overdue', header: S.overdue, type: 'bool', width: 110 },
      { key: 'status', header: S.status, type: 'enum', width: 130, options: GDPR_STATUS_OPTS },
    ],
    [],
  )
  const fetcher = useCallback(fetchDataExport, [])
  return (
    <>
      <PageHeader title={S.exportTitle} screenId="A19.15" description={S.exportDesc} />
      <DataTable<GdprRow>
        screenId="A19.15"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <FileDown size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
